import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Button, Box } from "@mui/material";
import AppInfoView from "@crema/core/AppInfoView";
import AppsContainer from "@crema/core/AppsContainer";
import AppsPagination from "@crema/core/AppsPagination";
import AppsContent from "@crema/core/AppsContainer/AppsContent";
import AppsHeader from "@crema/core/AppsContainer/AppsHeader";
import AppSearchBar from "@crema/core/AppSearchBar";
import { AppState } from "redux/store";
import { getCentre } from "redux/actions/support";
import CentreTable from "./CentreTable";
import { useNavigate } from "react-router-dom";

const Centre = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();
  const { centre, centreCount } = useSelector<AppState, AppState["support"]>(
    ({ support }) => support
  );

  const [page, setPage] = useState(0);
  const [search, setSearchQuery] = useState<string>("");

  const navigate = useNavigate();

  const onPageChange = (
    event: React.ChangeEvent<unknown> | null,
    value: number
  ) => {
    setPage(value);
  };

  useEffect(() => {
    dispatch(getCentre(search, page));
  }, [dispatch, search, page]);

  const onSearchCentre = (value: string) => {
    setSearchQuery(value);
    setPage(0);
  };

  const handleAddCentreClick = () => {
    navigate("/support/Centre/CentreCreate");
  };

  return (
    <>
      <AppsContainer
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: 16,
                fontWeight: "bold",
                color: "text.primary",
                flex: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {messages["sidebar.support.centre"]}
            </Box>
            <Button
             variant="outlined"
              color="primary"
              onClick={handleAddCentreClick}
              sx={{ flexShrink: 0 }}
            >
              Add centre
            </Button>
          </Box>
        }
        fullView
      >
        <AppsHeader>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              width: 1,
            }}
          >
            <AppSearchBar
              iconPosition="right"
              overlap={false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onSearchCentre(event.target.value)
              }
              placeholder={messages["common.searchHere"] as string}
            />
          </Box>
        </AppsHeader>

        <AppsContent
          sx={{
            paddingTop: 2.5,
            paddingBottom: 2.5,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <CentreTable centre={centre} />
          <AppsPagination
            rowsPerPage={10}
            count={centreCount}
            page={page}
            onPageChange={onPageChange}
          />
        </AppsContent>
      </AppsContainer>

      <AppInfoView />

      <AppInfoView />
    </>
  );
};

export default Centre;
